module.exports = __webpack_public_path__ + "static/media/facultyList.e13fdcf2.jfif";